import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default class NotFound extends Component {
  render () {
    return (
      <>
        <h1>404 - Page not found</h1>
        <pre>{window.location.href}</pre>
        <Button as={Link} to='/'>
          Home
        </Button>
      </>
    )
  }
}
